import React from "react";
import {Box} from "@material-ui/core";
import {DEFAULT_ICON, ICONS_MAP} from "../../constants/withdrawIcons";

import {TableItemWithSubtitle} from "../../../../../../../helpers/Display";
import {DisplayIdMerchant} from "../../../../../../../helpers/Display/DataDisplay";

export default ({id, short_id, status}) => (
  <Box
    width="100%"
    display="flex"
    alignItems="center"
  >
    <Box
      width="4.8rem"
      height="4.8rem"

      display="flex"
      justifyContent="center"
      alignItems="center"

      ml="2rem"
    >
      {ICONS_MAP[status] || DEFAULT_ICON}
    </Box>
    <Box pl="2rem">
      <TableItemWithSubtitle
        item={(
          <DisplayIdMerchant>
            {id}
          </DisplayIdMerchant>
        )}
        subItem={short_id && (
          <DisplayIdMerchant>
            {short_id}
          </DisplayIdMerchant>
        )}
        alignLeft
      />
    </Box>
  </Box>
)
